export const MapConfig = {
    googleMapsScriptUrl: 'https://maps.googleapis.com/maps/api/js?libraries=places&client=gme-adamopelag',
    mapOptions: {
        language: 'fr',
        zoom: 10,
        zoomControlOptions: {
        style: 2 // Reset when Google Map script is initialized (i.e. window.google.maps is available)
        }
    },
    directionsRendererOptions: {
        draggable: false,
        panel: null
    }
};
